
<template>
  <form @submit.prevent="validateBeforeSubmit">
    <section class="section has-text-dark has-background-white">
      <div class="container">
        <h1>Add a Comment</h1>
        <div class="columns">
          <div class="column is-2">
            <label class="label">{{labels.commentLabel}}*</label>
          </div>
          <div class="column is-5">
            <p class="control has-icon has-icon-right">
              <textarea v-model="model.Comment" placeholder="add multiple lines" class="textarea"></textarea>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-2">
            <label class="label">{{labels.ratingLabel}}*</label>
          </div>
          <div class="column is-5">
            <p class="control has-icon has-icon-right">
              <star-rating v-model="model.Rating"></star-rating>
            </p>
            <div class="field is-grouped is-grouped-right"><div class="control"><button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Submit</button></div></div>
          </div>
          
        </div>        
      </div>
    </section>
  </form>
</template>

<script>
  import { StarRating }  from 'vue-rate-it';


  export default {
    components: {
      StarRating
    },
    name: 'AddComment',
    data() {
      return {
        model: {
        },
        labels: [],
        loading: false
      }
    },
    created() {
      this.$http
        .get('/umbraco/surface/CommentSurface/AddComment')
        .then(response => {
          if (response.data.error) {
            this.$router.back();
          }
          else {
            this.model = response.data.model;
            this.labels = response.data.labels;
            this.model.Id = this.$route.query.id
          }
        })
        .catch(error => {
          this.errored = true
        })
    },
  
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/CommentSurface/PostAddComment',
                this.model
              )
              .then(response => {
                if (response.data.success) {
                  this.loading = false;
                  window.location.href = document.referrer
                }
                else {
                  this.loading = false;
                }
                 
                
              })
              .catch(error => {
                this.loading = false;
              });
            return;
          }


        });
      },
    }
  };
</script>
                  \



// WEBPACK FOOTER //
// src/components/AddComment.vue